import { Navigate } from "react-router-dom";
import { AppLayout } from "../layout";
import { PartnerDashboard } from "../pages/partner";
import { Login } from "../pages/login";
import { AnimationLayout } from "../layout/animation";
import { Register } from "../pages/register";
import { PartnerClients } from "../pages/partner/clients";
import { PartnerContracts } from "../pages/partner/contracts";
import { PartnerIndication } from "../pages/partner/indication";
import { PartnerExtract } from "../pages/partner/extract";
import { PartnerMailing } from "../pages/partner/mailing";

const PartnerRouters = [
    {
        path: "/parceiro",
        element: <AppLayout isClient={false} />,
        children: [
            {
                element: <PartnerDashboard />,
                path: "/parceiro/comissao",
            },
            {
                element: <PartnerClients />,
                path: "/parceiro",
            },
            {
                element: <PartnerContracts />,
                path: "/parceiro/contratos",
            },
            {
                element: <PartnerIndication />,
                path: "/parceiro/parceiros",
            },
            {
                element: <PartnerExtract />,
                path: "/parceiro/extrato",
            },
            {
                element: <PartnerMailing />,
                path: "/parceiro/mailing",
            },
            {
                element: <Navigate to="/parceiro" />,
                path: "/parceiro/*",
            },
        ]
    },
    {
        element: <Login />,
        path: "/cliente/login",
    },
    {
        element: <Navigate to="/cliente/login" />,
        path: "/cliente/*",
    },
    {
        element: <AnimationLayout />,
        children: [
            {
                element: <Register />,
                path: "/cadastro",
            },
        ]
    }
]

export default PartnerRouters;